import {post, get, del,put} from '@/utils/request'

/*
 * 查询网店商户列表
 */
export function getAllBaseAgentMemberInfo(data) {
    return post({
          data,
          url:'tbs/base-agent-member/getAllBaseAgentMemberInfo'
    })
}
/*
 * 查询网店商户个人列表
 */
export function getBaseAgentMemberInfo(data) {
    return post({
        url:'tbs/base-agent-member/getBaseAgentMemberInfo/'+data,
        loading: false
    })
}

/*
 * 新增网店
 */
export function insertOrUpdateBaseAgentMember(data) {
    return post({
        data,
        url:'tbs/base-agent-member/insertOrUpdateBaseAgentMember'
    })
}
/*
 * 禁用网店商户
 */
export function disableMember(data) {
    return put({
        url:'tbs/base-agent-member/disableMember/'+data
    })
}
/*
 * 启用网店商户
 */
export function enableMember(data) {
    return put({
        url:'tbs/base-agent-member/enableMember/'+data
    })
}

export function deleteMember(data) {
    return del({
        url:'tbs/base-agent-member/deleteMember/'+data
    })
}

export function getBankType() {
    return post({
        url:'tbs/sys-pa-code/getBankType',
        loading: false
    })
}


export function getHigeAgentMember() {
    return post({
        url:'tbs/base-agent-member/getHigeAgentMember',
        loading: false
    })
}

export function exportAgentMember(data) {
    return post({
        data,
        url:'tbs/base-agent-member/exportAgentMember'
    })
}